import { MainLayout } from '@templates/index';
import { LEGAL_CONFIG } from '@/config/legal';
import { Link } from 'react-router-dom';

interface JobListing {
  title: string;
  department: string;
  location: string;
  type: string;
  description: string;
}

const OPEN_POSITIONS: JobListing[] = [
  {
    title: 'Senior Backend Geliştirici (NestJS)',
    department: 'Mühendislik',
    location: 'Adana / Uzaktan',
    type: 'Tam Zamanlı',
    description:
      'NestJS, TypeScript ve PostgreSQL konularında deneyimli, ölçeklenebilir mikro-servis mimarisi kurabilen bir geliştirici arıyoruz.',
  },
  {
    title: 'Flutter Mobil Geliştirici',
    department: 'Mühendislik',
    location: 'Adana / Uzaktan',
    type: 'Tam Zamanlı',
    description:
      'iOS ve Android için yüksek performanslı Flutter uygulamaları geliştirme konusunda deneyimli, Clean Architecture prensiplerini benimseyen bir geliştirici arıyoruz.',
  },
  {
    title: 'Ürün Tasarımcısı (UI/UX)',
    department: 'Tasarım',
    location: 'Adana / Uzaktan',
    type: 'Tam Zamanlı',
    description:
      'Kullanıcı araştırması, wireframe ve prototip oluşturma konularında deneyimli, Figma ile çalışabilen bir ürün tasarımcısı arıyoruz.',
  },
  {
    title: 'Operasyon Uzmanı',
    department: 'Operasyon',
    location: 'Adana',
    type: 'Tam Zamanlı',
    description:
      'Restoran ve kurye ortaklıklarını yönetecek, saha operasyonlarını koordine edecek, analitik düşünce yapısına sahip bir operasyon uzmanı arıyoruz.',
  },
  {
    title: 'Müşteri Deneyimi Uzmanı',
    department: 'Müşteri Hizmetleri',
    location: 'Adana / Uzaktan',
    type: 'Tam Zamanlı',
    description:
      'Müşteri memnuniyetini en üst düzeye çıkarmak için destek taleplerini yönetecek, empati ve çözüm odaklı iletişim becerisine sahip bir uzman arıyoruz.',
  },
];

const PERKS = [
  { icon: '🚀', title: 'Hızlı Büyüme', desc: 'Erken aşama startup ortamında hızlı kariyer gelişimi' },
  { icon: '🏠', title: 'Esnek Çalışma', desc: 'Hibrit ve uzaktan çalışma seçenekleri' },
  { icon: '📚', title: 'Öğrenme Bütçesi', desc: 'Kurs, konferans ve kitap için yıllık eğitim bütçesi' },
  { icon: '🍕', title: 'Yemek Kredisi', desc: 'Aylık platform yemek kredisi' },
  { icon: '💡', title: 'Fikir Özgürlüğü', desc: 'Fikirlerinizin doğrudan ürüne yansıdığı kültür' },
  { icon: '🤝', title: 'Hisse Senedi', desc: 'Erken çalışanlar için hisse senedi opsiyonu programı' },
];

const CareerPage = () => {
  return (
    <MainLayout>
      {/* Hero */}
      <section className="bg-gradient-to-br from-[#E63946] to-rose-700 text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl font-bold mb-4">Lezzet Yolda&apos;da Kariyer</h1>
          <p className="text-rose-100 text-lg max-w-2xl mx-auto">
            Türkiye&apos;nin en hızlı büyüyen yemek teslimat platformunu birlikte inşa ediyoruz.
            Tutkulu, meraklı ve çözüm odaklı insanları arıyoruz.
          </p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto py-12 px-4">
        {/* Perks */}
        <section className="mb-14">
          <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">
            Neden Lezzet Yolda?
          </h2>
          <p className="text-gray-500 text-center mb-8">
            Büyük bir ailenin parçası olmak için birçok neden var.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {PERKS.map((perk) => (
              <div
                key={perk.title}
                className="bg-white border border-gray-200 rounded-2xl p-5 hover:shadow-md transition-shadow"
              >
                <div className="text-2xl mb-2">{perk.icon}</div>
                <h3 className="font-semibold text-gray-900 text-sm mb-1">{perk.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{perk.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Open Positions */}
        <section className="mb-14">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Açık Pozisyonlar</h2>
          <p className="text-gray-500 mb-6">
            Aradığınız pozisyonu bulamadıysanız açık başvuru için{' '}
            <a
              href={`mailto:${LEGAL_CONFIG.email}?subject=Açık%20Başvuru`}
              className="text-[#E63946] hover:underline font-medium"
            >
              e-posta gönderin
            </a>
            .
          </p>

          <div className="space-y-4">
            {OPEN_POSITIONS.map((job) => (
              <div
                key={job.title}
                className="bg-white border border-gray-200 rounded-2xl p-6 hover:border-[#E63946]/40 hover:shadow-sm transition-all"
              >
                <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                  <div>
                    <h3 className="font-bold text-gray-900">{job.title}</h3>
                    <div className="flex flex-wrap gap-2 mt-1.5">
                      <Badge color="blue">{job.department}</Badge>
                      <Badge color="gray">{job.location}</Badge>
                      <Badge color="green">{job.type}</Badge>
                    </div>
                  </div>
                  <a
                    href={`mailto:${LEGAL_CONFIG.email}?subject=Başvuru:%20${encodeURIComponent(job.title)}`}
                    className="shrink-0 px-4 py-2 bg-[#E63946] text-white rounded-xl text-sm font-semibold hover:bg-red-600 transition-colors"
                  >
                    Başvur
                  </a>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{job.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Process */}
        <section className="mb-14">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Başvuru Süreci
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {[
              { step: '01', title: 'Başvur', desc: 'CV ve kısa tanıtım yazısıyla e-posta gönderin' },
              { step: '02', title: 'Ön Görüşme', desc: 'İK ekibimizle 30 dakikalık tanışma görüşmesi' },
              { step: '03', title: 'Teknik / Vaka', desc: 'Pozisyona özel teknik değerlendirme veya vaka çalışması' },
              { step: '04', title: 'Teklif', desc: 'Olumlu sonuçta teklif ve onboarding süreci' },
            ].map((item) => (
              <div key={item.step} className="text-center">
                <div className="w-12 h-12 bg-[#E63946] text-white rounded-2xl flex items-center justify-center font-bold text-lg mx-auto mb-3">
                  {item.step}
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Açık pozisyon bulamadınız mı?
          </h3>
          <p className="text-gray-500 text-sm mb-5">
            Yetenekli insanlara her zaman kapımız açık. Özgeçmişinizi gönderin, uygun bir pozisyon
            açıldığında sizi arayalım.
          </p>
          <a
            href={`mailto:${LEGAL_CONFIG.email}?subject=Açık%20Başvuru`}
            className="inline-block px-6 py-3 bg-[#E63946] text-white rounded-xl font-semibold hover:bg-red-600 transition-colors"
          >
            Açık Başvuru Yap
          </a>
          <p className="text-xs text-gray-400 mt-3">
            veya{' '}
            <Link to="/contact" className="hover:underline">
              iletişim formunu
            </Link>{' '}
            kullanın
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

function Badge({ children, color }: { children: React.ReactNode; color: 'blue' | 'gray' | 'green' }) {
  const classes = {
    blue: 'bg-blue-50 text-blue-700',
    gray: 'bg-gray-100 text-gray-600',
    green: 'bg-green-50 text-green-700',
  };
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${classes[color]}`}>
      {children}
    </span>
  );
}

export default CareerPage;
